import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import { primaryShade } from "../../../../../common/ui/Styles";

const Styled = {
  BgCircle: styled.circle`
    stroke: ${cloud.getShade(4)};
    fill: none;
  `,
  FgCircle: styled.circle`
    transform: rotate(-90deg);
    transform-origin: center;
    stroke: ${primaryShade(6)};
    fill: none;
  `,
};

const SIZE = 34;
const RING_SIZE = 4;

export default function ProgressCircle({ percent }) {
  const lastUpdateTime = useRef(Date.now());

  useEffect(() => {
    lastUpdateTime.current = Date.now();
  }, [percent]);

  const innerSize = SIZE - RING_SIZE;
  const trueRadius = SIZE / 2;
  const drawRadius = innerSize / 2;
  const circumference = 2 * Math.PI * drawRadius;

  const commonProps = {
    cx: trueRadius,
    cy: trueRadius,
    r: drawRadius,
    strokeWidth: RING_SIZE,
  };

  return (
    <svg
      focusable="false"
      aria-hidden={true}
      width={SIZE}
      height={SIZE}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={percent}
    >
      <Styled.BgCircle {...commonProps} />
      <Styled.FgCircle
        {...commonProps}
        strokeDasharray={circumference}
        strokeDashoffset={(circumference * (100 - percent)) / 100}
        style={{
          transition: `stroke-dashoffset ${
            Date.now() - lastUpdateTime.current
          }ms`,
        }}
      />
    </svg>
  );
}
